import { Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-change-status',
  templateUrl: './dialog-change-status.component.html',
  styleUrls: ['./dialog-change-status.component.scss']
})
export class DialogChangeStatusComponent implements OnInit {
  statusUser = [
      {id: 0, name: 'Chưa kích hoạt', color: '#FF8038'},
      {id: 1, name: 'Kích hoạt', color: '#1355C1'},
      {id: 2, name: 'Bị khóa', color: '#283C63'},
      {id: 3, name: 'Bị xóa', color: '#C4C4C4'},];
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialog: MatDialogRef<DialogChangeStatusComponent>
  ) { }

  ngOnInit(): void {
  }

  confirmStatus(){
    this.dialog.close(true);
  }

}
